const mapperToMentions = (
    mentions,
    id = 'id',
    value = 'title',
    user_id = 'user_id',
    user_name = 'user_name',
    user_picture = 'user_picture',
    period_name = 'period_name'
) => {
    return mentions.map(mention => {
        return {
            id: mention[id],
            value: mention[value],
            user_id: mention[user_id],
            user_name: mention[user_name],
            user_picture: mention[user_picture],
            period_name: mention[period_name],
        }
    })
}

export { mapperToMentions }
